import { render, staticRenderFns } from "./Dicker.vue?vue&type=template&id=2f3f2469&scoped=true"
import script from "./Dicker.vue?vue&type=script&lang=js"
export * from "./Dicker.vue?vue&type=script&lang=js"
import style0 from "./Dicker.vue?vue&type=style&index=0&id=2f3f2469&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3f2469",
  null
  
)

export default component.exports